const DB_NAME = "pixel-cake-stitcher";
const STORE_NAME = "tasks";
const DB_VERSION = 1;

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const store = request.result.createObjectStore(STORE_NAME, { keyPath: "taskId" });
      store.createIndex("createdAt", "createdAt");
      store.createIndex("canvasSize", "canvasSize");
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveTask(manifest) {
  const db = await openDatabase();
  const task = {
    taskId: manifest.taskId,
    createdAt: manifest.createdAt || new Date().toISOString(),
    canvasSize: `${manifest.canvas.width}x${manifest.canvas.height}`,
    imageCount: manifest.images.length,
    fileName: manifest.compositeFileName,
    manifest,
  };
  await transaction(db, "readwrite", (store) => store.put(task));
  return task;
}

export async function listTasks(query = "") {
  const db = await openDatabase();
  const tasks = await transaction(db, "readonly", (store) => store.getAll());
  const needle = query.trim().toLowerCase();
  return tasks
    .filter((task) => !needle || `${task.taskId} ${task.fileName} ${task.canvasSize}`.toLowerCase().includes(needle))
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

export async function getTask(taskId) {
  const db = await openDatabase();
  return transaction(db, "readonly", (store) => store.get(taskId));
}

export async function deleteTask(taskId) {
  const db = await openDatabase();
  return transaction(db, "readwrite", (store) => store.delete(taskId));
}

function transaction(db, mode, operation) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, mode);
    const request = operation(transaction.objectStore(STORE_NAME));
    transaction.oncomplete = () => resolve(request?.result);
    transaction.onerror = () => reject(transaction.error);
  });
}
